export default "__VITE_ASSET__BZaQysPe__"